import React from 'react';
import { Button, DashedTitle } from '@fasstech/middle-design-system';
import { useFormContext } from 'react-hook-form';
import { ControlledInput, ControlledSelect } from '@@viewCommonComponents/controlled/index.js';
import { isRequiredSelect, isValidCompanyName, isValidSirenSiret } from '@@viewHelpers/validations/index.js';
import { propOr } from 'ramda';
import CompaniesList from './CompaniesList.jsx';
import Ccns from './Ccns.jsx';

const FindACompanyForm = ({
  getMiddleText,
  departments,
  onSearch,
  onSearchCcns,
  companies,
  setCompanies,
  loading,
  disableSearch,
  ccns,
  loadingCcns,
  selectedCompany,
  setSelectedCompany,
  noCompaniesFound,
  setCcns,
  noCCN,
  setNoCCN,
  otherCcns,
  loadingOtherCcns,
  onSearchOtherCcns,
  options,
  optionsOtherCcns,
  onSearchCcnOffer,
  ccnOffer,
  loadingCcnOffer,
  setCcnOffer,
  setOtherCcns,
  onSearchFlexiproduct
}) => {
  const form = useFormContext();
  return (
    <>
      <DashedTitle>
        {getMiddleText('ENTREPRISE_RECH_ENTREPRISE_ETAB_TITLE_SOUS_BLOC')}
      </DashedTitle>
      <div className={'w-full flex justify-start'}>
        <div className={'flex flex-col gap-4'}>
          <div className={'flex flex-col gap-2'}>
            <p>
              {getMiddleText(
                'ENTREPRISE_RECH_ENTREPRISE_SIREN_SIRET_TITLE_LABEL'
              )}
            </p>
            <ControlledInput
              name="company.history.siret"
              label={getMiddleText(
                'ENTREPRISE_RECH_ENTREPRISE_SIREN_SIRET_LABEL'
              )}
              form={form}
              withIndicator
              rules={isValidSirenSiret(false)}
              displayErrorMessage
              mask="999 999 999 99999"
              maskPlaceholder=" "
              data-testid="ENTREPRISE_SIRET"
            />
          </div>

          <div className={'flex flex-col gap-2'}>
            <p>{getMiddleText('ENTREPRISE_RECH_ENTREPRISE_NOM_TITLE_LABEL')}</p>
            <ControlledInput
              name="company.history.name"
              label={getMiddleText('ENTREPRISE_NOM_LABEL')}
              form={form}
              withIndicator
              rules={isValidCompanyName(false)}
              displayErrorMessage
              data-testid="ENTREPRISE_NOM"
            />
          </div>

          <ControlledSelect
            name="company.history.department"
            label={getMiddleText('ENTREPRISE_RECH_ENTREPRISE_DEPT_LABEL')}
            options={propOr([], 'departments', departments)}
            rules={isRequiredSelect(
              propOr([], 'departments', departments),
              false
            )}
            form={form}
            withIndicator
            data-testid="ENTREPRISE_DEPARTEMENT"
          />

          {/*todo add feat create company*/}
          {/*<Button variant="outline">*/}
          {/*  {getMiddleText('ENTREPRISE_CREATION_BOUTON_LABEL')}*/}
          {/*</Button>*/}

          <Button
            onClick={() => {
              setSelectedCompany({});
              form.setValue('company.ccnRef', null);
              onSearch();
            }}
            disabled={disableSearch}
          >
            Rechercher
          </Button>
        </div>
      </div>
      <CompaniesList
        loading={loading}
        companies={companies}
        setCompanies={setCompanies}
        getMiddleText={getMiddleText}
        setSelectedCompany={setSelectedCompany}
        selectedCompany={selectedCompany}
        onSearchCcns={onSearchCcns}
        noCompaniesFound={noCompaniesFound}
        setCcns={setCcns}
        setCcnOffer={setCcnOffer}
        form={form}
      />
      <Ccns
        ccns={ccns}
        loadingCcns={loadingCcns}
        getMiddleText={getMiddleText}
        form={form}
        noCCN={noCCN}
        setNoCCN={setNoCCN}
        otherCcns={otherCcns}
        loadingOtherCcns={loadingOtherCcns}
        onSearchOtherCcns={onSearchOtherCcns}
        options={options}
        optionsOtherCcns={optionsOtherCcns}
        onSearchCcnOffer={onSearchCcnOffer}
        ccnOffer={ccnOffer}
        loadingCcnOffer={loadingCcnOffer}
        setCcnOffer={setCcnOffer}
        setOtherCcns={setOtherCcns}
        selectedCompany={selectedCompany}
        onSearchFlexiproduct={onSearchFlexiproduct}
      />
    </>
  );
};

export default FindACompanyForm;
